"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceLg } from "@nxt-costco-com/forge-design-tokens";
const ParentWrapper = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: ${SpaceLg};

    > div:empty {
        display: none;
    }
`;
const ChildWrapper = styled(Box)`
    min-width: 172px;
    flex-grow: 1;

    &:has(> div > div:only-child:empty) {
        display: none;
    }

    &:has(> div:only-child:empty) {
        display: none;
    }

    &:has(> div[role='separator']:empty) {
        display: inherit;
        min-width: 0;
        flex: 0;
        flex-grow: 0;
    }

    &:has(> div > div[data-layout='full']),
    &:has(> div > div[data-layout='full_1']),
    &:has(
            > button[data-layout='ad_with_popup']
                > div
                > div[data-layout='full']
        ),
    &:has(
            > button[data-layout='ad_with_popup']
                > div
                > div[data-layout='full_1']
        ),
    &:has(
            > button[data-layout='ad_with_popup']
                > div[data-layout='aduilder_full']
        )
        &:has(> div[data-layout='aduilder_full']) {
        width: 100%;
    }

    &:has(
            > button[data-layout='ad_with_popup']
                > div
                > div[data-layout='one_fourth_mix']
        ),
    &:has(
            > button[data-layout='ad_with_popup']
                > div
                > div[data-layout='large_half_banner']
        ),
    &:has(> div > div[data-layout='one_fourth_mix']),
    &:has(> div > div[data-layout='large_half_banner']) {
        width: calc(50% - 16px);
        flex-grow: 0;

        @media (max-width: 768px) {
            width: 100%;
            flex-grow: 1;
        }
    }

    &:has(
            > button[data-layout='ad_with_popup']
                > div[data-layout='aduilder_one_half']
        ),
    &:has(> div[data-layout='aduilder_one_half']) {
        width: calc(50% - 16px);
        flex-grow: 0;

        @media (max-width: 768px) {
            width: 100%;
            flex-grow: 1;
        }
    }

    &:has(
            > button[data-layout='ad_with_popup']
                > div[data-layout='aduilder_one_third']
        ),
    &:has(> div[data-layout='aduilder_one_third']) {
        width: calc(33% - 16px);
        flex-grow: 0;

        @media (max-width: 768px) {
            width: 100%;
            flex-grow: 1;
        }
    }

    &:has(
            > button[data-layout='ad_with_popup']
                > div[data-layout='aduilder_one_fourth']
        ),
    &:has(> div[data-layout='aduilder_one_fourth']) {
        width: calc(25% - 16px);
        flex-grow: 0;

        @media (max-width: 768px) {
            width: 100%;
            flex-grow: 1;
        }
    }

    &:has(
            > button[data-layout='ad_with_popup']
                > div[data-layout='one_fourth_4']
        ),
    &:has(> div[data-layout='one_fourth_4']) {
        width: calc(25% - 16px);
        flex-grow: 0;
    }

    &:has(
            > button[data-layout='ad_with_popup']
                > div[data-layout='one_third_3']
        ),
    &:has(> div[data-layout='one_third_3']) {
        width: calc(33% - 16px);
        flex-grow: 0;
    }

    &:has(> button[data-layout='ad_with_popup'] > div[data-layout='half_2']),
    &:has(> div[data-layout='half_2']) {
        width: calc(50% - 16px);
        flex-grow: 0;
    }

    &:has(> button[data-layout='ad_with_popup'] > div[data-layout='full_1']),
    &:has(> div[data-layout='full_1']) {
        width: 100%;
    }

    // Handles strips that contain RichText components
    &:has(> div[data-layout='rich_text_half']) {
        flex: 0 0 calc(50% - 24px / 2); // 24px = row gap
        @media (max-width: 768px) {
            flex: 1 0 100%;
        }
    }
    &:has(> div[data-layout='rich_text_half_grow']) {
        flex: 1 0 calc(50% - 24px / 2); // 24px = row gap
        @media (max-width: 768px) {
            flex: 1 0 100%;
        }
    }
    &:has(> div[data-layout='rich_text_full']) {
        flex: 1 0 100%;
    }
`;
export {
  ChildWrapper,
  ParentWrapper
};
